import api from './api'

export interface FAQItem {
  id: number
  question: string
  answer: string
  category: string
  sort_order: number
  is_published?: boolean
  created_at?: string
  updated_at?: string
}

export interface FAQCreate {
  question: string
  answer: string
  category: string
  sort_order?: number
  is_published?: boolean
}

export const faqService = {
  async getPublished(): Promise<FAQItem[]> {
    const response = await api.get('/faq')
    return response.data
  },

  async getAll(): Promise<FAQItem[]> {
    const response = await api.get('/faq/admin')
    return response.data
  },

  async create(data: FAQCreate): Promise<FAQItem> {
    const response = await api.post('/faq/admin', data)
    return response.data
  },

  async update(id: number, data: Partial<FAQCreate>): Promise<FAQItem> {
    const response = await api.put(`/faq/admin/${id}`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/faq/admin/${id}`)
  },
}
